import { Theme } from "@emotion/react"
import React from "react"
import { ncsWhite } from "~/images/logos"
import { addressStyle } from "./styles"

const AddressFooter: React.FC = () => (
	<div css={addressStyle}>
		<img
			src={ncsWhite}
			width="128"
			height="40"
			loading="lazy"
			alt="NCS logo"
			aria-hidden="true"
		/>
		<p>1500 SE 37th St.</p>
		<p>Grimes, IA 50111</p>
	</div>
)

export default AddressFooter
